<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <button
        id="botaoPesquisar"
        data-test-id="button-pesquisar"
        type="submit"
        name="botaoPesquisar"
        class="btn btn-primary no-radius"
        @click="pesquisar()"
      >
        Pesquisar
      </button>
      <span v-if="ordenarPor.length">
        <button
          id="botaoOrdenar"
          data-test-id="button-ordenar"
          type="button"
          name="botaoOrdenar"
          class="btn btn-primary dropdown-toggle no-radius"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Ordenar por
          <span class="caret" />
        </button>
        <ul class="dropdown-menu">
          <li
            v-for="(propriedade, index) in ordenarPor"
            :key="propriedade"
            :class="propriedadeSelecionada === propriedade ? 'active' : ''"
          >
            <a
              :data-test-id="`link-ordenar-${propriedade}`"
              href="#"
              @click.prevent="ordenar(propriedade)"
            >
              {{ ordenarNomes[index] }}
            </a>
          </li>
        </ul>
      </span>
      <button
        id="botaoLimpar"
        data-test-id="button-limpar"
        type="button"
        name="botaoLimpar"
        class="btn btn-danger no-radius"
        @click="limpar"
      >
        Limpar
      </button>
      <button
        v-if="botaoExportar"
        id="botaoExportarCSV"
        data-test-id="button-exportar-csv"
        type="button"
        name="botaoExportarCSV"
        class="btn btn-success"
        @click="exportarCSV"
      >
        Exportar CSV
      </button>
      <button
        v-if="botaoDownload"
        id="botaoDownload"
        data-test-id="button-download-relatorio"
        type="button"
        name="botaoDownload"
        class="btn btn-success"
        @click="download"
      >
        Baixar Relatório
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolbarPesquisa',
  props: {
    ordenarPor: {
      type: Array,
      default: () => {
        return []
      },
    },
    ordenarNomes: {
      type: Array,
      default: () => {
        return []
      },
    },
    dados: {
      type: Array,
      default: () => {
        return []
      },
    },
    botaoExportar: {
      type: Boolean,
      default: false,
    },
    botaoDownload: {
      type: Boolean,
      default: false,
    },
    nomeDoForm: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      propriedadeSelecionada: '',
    }
  },
  methods: {
    pesquisar() {
      this.$emit('pesquisar')
    },
    limpar() {
      if (this.nomeDoForm) {
        this.removerFormularioDoCache(this.nomeDoForm)
      }

      location.reload()
    },
    removerFormularioDoCache(nomeDoForm) {
      const formularioCache = window.localStorage.getItem('tu.formularioCache')

      if (!formularioCache) {
        return
      }

      let sessionData

      try {
        sessionData = JSON.parse(formularioCache)
      } catch {
        return
      }

      if (!sessionData || !sessionData[nomeDoForm]) {
        return
      }

      delete sessionData[nomeDoForm]
      window.localStorage.setItem(
        'tu.formularioCache',
        JSON.stringify(sessionData)
      )
    },
    ordenar(propriedade) {
      this.propriedadeSelecionada = propriedade
      this.$emit('ordenar', propriedade)
    },
    exportarCSV() {
      this.$emit('exportarCSV')
    },
    download() {
      this.$emit('download')
    },
  },
}
</script>

<style>
.btn.no-radius {
  border-radius: 0;
}
</style>
